// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".uJtWmxU6peMcWiB1GSQlu p,.uJtWmxU6peMcWiB1GSQlu ul{margin-bottom:1.6rem}.uJtWmxU6peMcWiB1GSQlu ul{padding-left:3.2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"seo": "uJtWmxU6peMcWiB1GSQlu"
};
module.exports = ___CSS_LOADER_EXPORT___;
